var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileblue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 195 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.404 66.5785C152.404 108.593 128.859 144.65 97.5053 144.65C66.1275 144.65 42.6064 108.593 42.6064 66.5653C42.6064 24.5642 62.858 0 97.5053 0C132.153 0 152.404 24.5511 152.404 66.5785ZM1.15172 238.567C5.84862 244.59 26.0758 263 97.5053 263C168.935 263 189.15 244.59 193.859 238.58C194.296 238.003 194.618 237.335 194.807 236.618C194.996 235.902 195.047 235.151 194.957 234.412C193.883 222.814 184.197 170.95 97.5053 170.95C10.8139 170.95 1.12732 222.814 0.0415459 234.412C-0.0468055 235.152 0.00609817 235.903 0.197013 236.62C0.387928 237.337 0.712822 237.991 1.15172 238.567Z",
    fill: "#53B7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileblue);
export default __webpack_public_path__ + "static/media/profileblue.138acdf12e1bdea88e8aeae296201e9b.svg";
export { ForwardRef as ReactComponent };